<template>
  <div class="adauga-factura-intrare-vertical d-flex flex-column gap-4">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="fw-bold mb-0">Adaugă factură intrare</h5>
      <slot name="actions"></slot>
    </div>

    <div class="d-flex flex-column gap-3">
      <!-- Serie + număr -->
      <div>
        <label class="form-label mb-1">Serie și număr</label>
        <div class="d-flex gap-2">
          <input
            id="serie_document"
            v-model="factura.serie_document"
            type="text"
            class="form-control flex-grow-1"
            placeholder="Serie"
          >
          <input
            v-model="factura.nr_document"
            type="text"
            class="form-control"
            style="max-width: 120px;"
            placeholder="Nr."
          >
        </div>
      </div>

      <!-- Furnizor -->
      <div>
        <label class="form-label mb-1">Furnizor</label>
        <multiselect
          id="id_furnizor"
          v-model="furnizorObj"
          :options="listaFurnizori"
          :custom-label="furnizorLabel"
          track-by="id"
          placeholder="Furnizor"
          class="w-100"
          :open-direction="'bottom'"
          :select-label="''"
          :deselect-label="''"
          :selected-label="''"
        />
      </div>

      <!-- Date document -->
      <div class="d-flex flex-column gap-2">
        <div class="d-flex flex-column">
          <label class="form-label mb-1">Data emiterii</label>
          <div class="position-relative">
            <input
              ref="dateEmitereRef"
              v-model="factura.data_emitere"
              type="date"
              class="form-control pe-5"
            />
            <button
              type="button"
              class="date-picker-btn btn btn-outline-secondary btn-sm"
              @click="openNativePicker('emitere')"
              aria-label="Deschide calendar"
            >
              📅
            </button>
          </div>
        </div>
        <div class="d-flex flex-column">
          <label class="form-label mb-1">Data scadenței</label>
          <div class="position-relative">
            <input
              ref="dateScadentaRef"
              v-model="factura.termen_plata"
              type="date"
              class="form-control pe-5"
            />
            <button
              type="button"
              class="date-picker-btn btn btn-outline-secondary btn-sm"
              @click="openNativePicker('scadenta')"
              aria-label="Deschide calendar"
            >
              📅
            </button>
          </div>
        </div>
      </div>

      <!-- Sold & e-Factura -->
      <div class="d-flex flex-wrap gap-3">
        <div class="flex-fill">
          <label class="form-label mb-1">Sold furnizor</label>
          <input
            :value="formattedSold"
            type="text"
            class="form-control"
            disabled
          >
        </div>
      </div>

      <!-- Valută & curs -->
      <div class="d-flex flex-wrap gap-3">
        <div style="min-width: 140px;">
          <label class="form-label mb-1">Valută</label>
          <multiselect
            v-model="valutaObj"
            :options="valute"
            :custom-label="valutaLabel"
            track-by="id"
            placeholder="Valută"
            class="w-100"
            :open-direction="'bottom'"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
          />
        </div>
        <div class="flex-fill">
          <label class="form-label mb-1">Curs valutar</label>
          <input
            v-model="factura.curs_valutar"
            type="number"
            step="0.0001"
            class="form-control"
            placeholder="Curs BNR"
          >
        </div>
      </div>

      <!-- Buton afișare detalii suplimentare -->
      <div class="mt-2">
        <button
          type="button"
          class="btn btn-sm btn-light btn-outline-secondary"
          @click="showMore = !showMore"
        >
          {{ showMore ? 'Ascunde detalii' : 'Afișează mai mult' }}
        </button>
      </div>

      <template v-if="showMore">
        <!-- Delegat -->
        <div class="d-flex flex-column gap-2 mt-3">
          <div>
            <label class="form-label mb-1">Delegat</label>
            <input
              v-model="factura.delegat_nume"
              type="text"
              class="form-control"
              placeholder="Nume delegat"
            >
          </div>
          <div>
            <label class="form-label mb-1">Date delegat</label>
            <input
              v-model="factura.delegat_date"
              type="text"
              class="form-control"
              placeholder="CNP / CI / alte detalii"
            >
          </div>
          <div>
            <label class="form-label mb-1">Auto delegat</label>
            <input
              v-model="factura.delegat_auto"
              type="text"
              class="form-control"
              placeholder="Număr auto"
            >
          </div>
        </div>

        <!-- Intocmit -->
        <div class="d-flex flex-column gap-2 mt-3">
          <div>
            <label class="form-label mb-1">Întocmit de</label>
            <input
              v-model="factura.intocmit_de"
              type="text"
              class="form-control"
              placeholder="Nume persoană"
            >
          </div>
          <div>
            <label class="form-label mb-1">CNP întocmit</label>
            <input
              v-model="factura.intocmit_cnp"
              type="text"
              class="form-control"
              placeholder="CNP"
            >
          </div>
        </div>

        <!-- Informatii suplimentare -->
        <div class="mt-3">
          <label class="form-label mb-1">Informații suplimentare</label>
          <textarea
            v-model="factura.informatii_suplimentare"
            rows="3"
            class="form-control"
            placeholder="Note, observații, condiții speciale..."
          ></textarea>
        </div>
      </template>

      <!-- Produse -->
      <div class="mt-3">
        <label class="form-label mb-1">Produse</label>
        <div class="table-responsive">
          <table class="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Denumire</th>
                <th>Cant.</th>
                <th>UM</th>
                <th>Preț</th>
                <th>TVA %</th>
                <th>Valoare</th>
                <th>TVA</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(p, idx) in produseLocal">
                <!-- VIEW ROW: compact summary when not editing -->
                <tr v-if="!p._editing" :key="`prod-view-${idx}`">
                  <td>{{ p.pozitie || idx + 1 }}</td>
                  <td>{{ p.denumire }}</td>
                  <td>{{ p.cantitate }}</td>
                  <td>{{ formatUm(p.um) }}</td>
                  <td>{{ p.pret }}</td>
                  <td>{{ p.cota_tva }}</td>
                  <td>{{ p.valoare }}</td>
                  <td>{{ p.valoare_tva }}</td>
                  <td>{{ p.total }}</td>
                  <td class="text-end">
                    <button
                      type="button"
                      class="btn btn-xs btn-light-primary me-1"
                      @click="editProdus(idx)"
                    >
                      Editează
                    </button>
                    <button
                      type="button"
                      class="btn btn-xs btn-light-danger"
                      @click="removeProdus(idx)"
                    >
                      Șterge
                    </button>
                  </td>
                </tr>

                <!-- EDIT ROW: full form card when editing -->
                <tr v-else :key="`prod-edit-${idx}`">
                  <td colspan="10" class="p-0">
                    <div class="border rounded p-3 mb-2 d-flex flex-column gap-3 bg-light-subtle">

                      <!-- ROW 1: DENUMIRE + BADGE # -->
                      <div class="d-flex flex-column">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <span class="badge bg-secondary">
                            #{{ p.pozitie || idx + 1 }}
                          </span>
                        </div>
                        <label class="form-label mb-1 fw-bold">Denumire produs</label>
                        <input
                          v-model="p.denumire"
                          type="text"
                          class="form-control form-control-lg"
                          placeholder="Denumirea completă a produsului / serviciului"
                        >
                      </div>

                      <!-- ROW 2: # linie + TIP -->
                      <div class="row g-3">
                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold"># linie</label>
                          <input
                            v-model.number="p.pozitie"
                            type="number"
                            min="1"
                            class="form-control form-control-lg"
                          >
                        </div>
                        <div class="col-6 col-md-9">
                          <label class="form-label mb-1 fw-bold">Tip</label>
                          <multiselect
                            v-model="p.tip"
                            :options="tipuriProduse"
                            track-by="id"
                            label="text"
                            placeholder="Alege tip"
                            class="w-100"
                            :open-direction="'bottom'"
                            :select-label="''"
                            :deselect-label="''"
                            :selected-label="''"
                          />
                        </div>
                      </div>

                      <!-- ROW 3: GRID WITH BIG FIELDS -->
                      <div class="row g-3">

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">Cantitate</label>
                          <input
                            v-model.number="p.cantitate"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control form-control-lg"
                            @input="onProdusChanged(p)"
                          >
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">UM</label>
                          <multiselect
                            v-model="p.um"
                            :options="unitatiMasura"
                            track-by="id"
                            label="text"
                            placeholder="Alege UM"
                            class="w-100"
                            :open-direction="'bottom'"
                            :select-label="''"
                            :deselect-label="''"
                            :selected-label="''"
                          />
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">Preț unitar</label>
                          <input
                            v-model.number="p.pret"
                            type="number"
                            min="0"
                            step="0.0001"
                            class="form-control form-control-lg"
                            @input="onProdusChanged(p)"
                          >
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">TVA (%)</label>
                          <input
                            v-model.number="p.cota_tva"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control form-control-lg"
                            @input="onProdusChanged(p)"
                          >
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">Valoare</label>
                          <input
                            v-model.number="p.valoare"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control form-control-lg"
                            readonly
                          >
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">TVA</label>
                          <input
                            v-model.number="p.valoare_tva"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control form-control-lg"
                            readonly
                          >
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">Total</label>
                          <input
                            v-model.number="p.total"
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-control form-control-lg fw-bold"
                            readonly
                          >
                        </div>

                      </div>

                      <!-- ACTION BUTTONS -->
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-light-danger"
                          @click="removeProdus(idx)"
                        >
                          Șterge produs
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          @click="saveProdus(idx)"
                        >
                          Salvează produs
                        </button>
                      </div>

                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="!produseLocal.length">
                <td colspan="10" class="text-muted small text-center py-3">
                  Niciun produs adăugat. Apasă „Adaugă produs”.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-light-primary"
            @click="addProdus"
          >
            + Adaugă produs
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'AdaugaFacturaIntrareVertical',
  components: { Multiselect },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    seriiFacturi: {
      type: Array,
      default: () => []
    },
    listaFurnizori: {
      type: Array,
      default: () => []
    },
    valute: {
      type: Array,
      default: () => []
    },
    unitatiMasura: {
      type: Array,
      default: () => []
    },
    tipuriProduse: {
      type: Array,
      default: () => []
    },
    produse: {
      type: Array,
      default: () => []
    },
    autoInit: {
      type: Boolean,
      default: true
    },
    initialNumar: {
      type: [String, Number],
      default: ''
    },
    soldFormatter: {
      type: Function,
      default: (val) => {
        if (val === null || val === undefined || val === '') return '';
        const n = Number(val) || 0;
        return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }
  },
  emits: ['update:modelValue', 'furnizor-selected', 'serie-selected', 'update:produse'],
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    factura: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    serieObj: {
      get() {
        return (
          this.seriiFacturi.find(s =>
            s.id === this.factura.serie_document ||
            s.value === this.factura.serie_document ||
            s.serie === this.factura.serie_document
          ) || this.factura.serie_document_obj || null
        );
      },
      set(val) {
        this.factura.serie_document = val
          ? (val.id ?? val.value ?? val.serie ?? null)
          : null;
        this.factura.serie_document_obj = val || null;
        this.$emit('serie-selected', val);
      }
    },
    furnizorObj: {
      get() {
        return (
          this.listaFurnizori.find(c =>
            c.id === this.factura.id_furnizor ||
            c.value === this.factura.id_furnizor ||
            c.id_furnizor === this.factura.id_furnizor ||
            c.id === this.factura.client ||
            c.value === this.factura.client
          ) || this.factura.furnizor_obj || this.factura.client_obj || null
        );
      },
      set(val) {
        const id = val
          ? (val.id ?? val.value ?? val.id_furnizor ?? null)
          : null;
        this.factura.id_furnizor = id;
        // compatibilitate cu vechiul câmp, dacă există
        this.factura.client = id;
        this.factura.furnizor_obj = val || null;
        this.factura.client_obj = val || null;
        this.$emit('furnizor-selected', val);
      }
    },
    formattedSold() {
      return this.soldFormatter(this.factura.sold);
    },
    produseLocal: {
      get() {
        return this.produse;
      },
      set(val) {
        this.$emit('update:produse', val);
      }
    },
    valutaObj: {
      get() {
        return (
          this.valute.find(v =>
            v.id === this.factura.valuta ||
            v.value === this.factura.valuta ||
            v.scurt === this.factura.valuta ||
            v.text === this.factura.valuta
          ) || this.factura.valuta_obj || null
        );
      },
      set(val) {
        const id = val
          ? (val.id ?? val.value ?? val.scurt ?? val.text ?? null)
          : null;
        this.factura.valuta = id;
        this.factura.valuta_obj = val || null;

        // dacă valuta are curs, îl setăm automat
        if (val && typeof val.curs !== 'undefined' && val.curs !== null) {
          const n = Number(val.curs);
          if (!Number.isNaN(n)) {
            this.factura.curs_valutar = n;
          }
        }
      }
    },
  },
  methods: {
    serieLabel(option) {
      if (!option) return '';
      return option.text || option.denumire || option.label || option.serie || String(option.id ?? option.value ?? '');
    },
    furnizorLabel(option) {
      if (!option) return '';
      return option.text || option.denumire || option.nume || option.label || String(option.id ?? option.value ?? '');
    },
    valutaLabel(option) {
      if (!option) return '';
      // ex: "EUR (4.97)"
      const base = option.text || option.scurt || option.label || String(option.id ?? option.value ?? '');
      if (option.curs !== undefined && option.curs !== null) {
        return `${base} (${option.curs})`;
      }
      return base;
    },
    toNumber(val, fallback = 0) {
      const n = Number(val);
      return Number.isNaN(n) ? fallback : n;
    },
    recalcProdus(p) {
      if (!p) return;
      const cant = this.toNumber(p.cantitate, 0);
      const pret = this.toNumber(p.pret, 0);
      const cota = this.toNumber(p.cota_tva, 0);

      const valoare = cant * pret;
      const valoare_tva = valoare * cota / 100;
      const total = valoare + valoare_tva;

      p.valoare = Number.isFinite(valoare) ? Number(valoare.toFixed(2)) : 0;
      p.valoare_tva = Number.isFinite(valoare_tva) ? Number(valoare_tva.toFixed(2)) : 0;
      p.total = Number.isFinite(total) ? Number(total.toFixed(2)) : 0;
    },
    onProdusChanged(p) {
      this.recalcProdus(p);
    },
    addProdus() {
      const nextPoz = (this.produseLocal?.length || 0) + 1;
      const nou = {
        pozitie: nextPoz,
        denumire: '',
        tip: 1,
        cota_tva: 19,
        um: null,
        cantitate: 1,
        pret: 0,
        valoare: 0,
        valoare_tva: 0,
        total: 0,
        cont_credit: null,
        _editing: true,
      };
      this.recalcProdus(nou);
      const arr = Array.isArray(this.produseLocal) ? [...this.produseLocal, nou] : [nou];
      this.produseLocal = arr;
    },
    removeProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      arr.splice(idx, 1);
      this.produseLocal = arr;
    },
    editProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      if (arr[idx]) {
        arr[idx]._editing = true;
        this.produseLocal = arr;
      }
    },
    saveProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      if (arr[idx]) {
        // basic sanity: dacă nu are denumire, nu închidem formularul
        if (!arr[idx].denumire || String(arr[idx].denumire).trim() === '') {
          return;
        }
        arr[idx]._editing = false;
        this.produseLocal = arr;
      }
    },
    formatUm(um) {
      if (!um) return '';
      if (typeof um === 'string') return um;
      if (typeof um === 'object') {
        return um.text || um.scurt || um.label || String(um.id ?? um.value ?? '');
      }
      return String(um);
    },
    openNativePicker(which) {
      if (which === 'emitere' && this.$refs.dateEmitereRef) {
        this.$refs.dateEmitereRef.showPicker?.();
      }
      if (which === 'scadenta' && this.$refs.dateScadentaRef) {
        this.$refs.dateScadentaRef.showPicker?.();
      }
    },
  },
  mounted() {
    if (this.autoInit) {
      if (this.valute.length && !this.factura.valuta) {
        const first = this.valute[0];
        this.valutaObj = first;
      }

      if (!this.factura.serie_document && this.seriiFacturi.length) {
        const last = this.seriiFacturi[this.seriiFacturi.length - 1];
        this.serieObj = last;
      }

      if (!this.factura.nr_document) {
        if (this.initialNumar) {
          this.factura.nr_document = String(this.initialNumar);
        } else if (this.factura.serie_document_obj && this.factura.serie_document_obj.last_nr) {
          const next = Number(this.factura.serie_document_obj.last_nr) + 1;
          if (!Number.isNaN(next)) {
            this.factura.nr_document = String(next);
          }
        }
      }

      // setăm automat data emiterii la data de azi dacă nu e deja setată
      if (!this.factura.data_emitere) {
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        this.factura.data_emitere = today;
      }
    }
  },

  watch: {
    seriiFacturi(newVal) {
      if (this.autoInit && newVal && newVal.length) {
        if (!this.factura.serie_document) {
          const last = newVal[newVal.length - 1];
          this.serieObj = last;
        }

        if (!this.factura.nr_document) {
          if (this.initialNumar) {
            this.factura.nr_document = String(this.initialNumar);
          } else if (this.factura.serie_document_obj?.last_nr) {
            const next = Number(this.factura.serie_document_obj.last_nr) + 1;
            if (!Number.isNaN(next)) {
              this.factura.nr_document = String(next);
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.adauga-factura-intrare-vertical {
  min-width: 320px;
}
.client-multiselect .multiselect__tags {
  border-radius: 0.475rem;
}
.multiselect {
  min-width: 0;
}

/* Force dark text inside vue-multiselect for visibility */
.multiselect :deep(.multiselect__input),
.multiselect :deep(.multiselect__single),
.multiselect :deep(.multiselect__tag),
.multiselect :deep(.multiselect__placeholder),
.multiselect :deep(.multiselect__content) {
  color: #181C32 !important; /* text vizibil pe fundal deschis */
}
.multiselect :deep(.multiselect__tags) {
  background-color: #fff;
  color: #181C32 !important;
}

input[type="date"].form-control {
  color: #181C32 !important;
  background-color: #ffffff !important;
}

.date-picker-btn {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  padding: 0.25rem 0.4rem;
}
</style>



